<template>
  <div class="tour-add-ons__wrapper">
    <div class="tour-add-ons__collapse-header">
      <h2 class="tour-add-ons__title">{{data.title}}</h2>
      <span v-if="isMobile()" class="add-ons__arrow add-ons__row--open" @click="hideShowAddonsList"></span>
    </div>

    <div class="tour-add-ons__description">
      <div v-html="data.descriptionHtml"></div>
    </div>

    <div v-if="this.openAddonsList" class="tour-add-ons__collapse-body">
      <div class="personalise-wrapper">
        <AddOn v-for="addon in visibleItems" :key="addon.code" :addon="addon" :data="data" :brand="brand"></AddOn>
      </div>

      <div v-if="isButtonVisible" class="cta-holder personalise-cta">
        <button
          class="btn"
          @click="toggleAmount"
        >{{isViewAll ? data.showLessResultsText : data.showMoreResultsText}}</button>
      </div>
    </div>
  </div>
</template>

<script>
import BaseList from './BaseList.vue';
import AddOn from './AddOn.vue';

export default {
  extends: BaseList,

  components: {
    AddOn
  },

  props: ["brand"],

  data() {
    return {
      itemsKey: 'addOns',
      openAddonsList: true,
    };
  },

  methods: {
    hideShowAddonsList() {
      if(this.openAddonsList) {
       this.openAddonsList = false;
       document.getElementsByClassName("add-ons__arrow")[0].classList.remove("add-ons__row--open");
     } else {
       this.openAddonsList = true;
       document.getElementsByClassName("add-ons__arrow")[0].classList.add("add-ons__row--open");
     }
    },

    isMobile() {
      if(screen.width <= 760)
        return true;
      return false;
    }
  }
};
</script>
